<div class="card-header-flex">
  <nz-tabset class="vb-tabs-bold" [nzSelectedIndex]="0">
    <nz-tab nzTitle="History"></nz-tab>
    <nz-tab nzTitle="Information"></nz-tab>
    <nz-tab nzTitle="Actions"></nz-tab>
  </nz-tabset>
</div>